import _ from 'lodash';
import {
  whitepapers as whitepapersLabel,
  webinars as webinarsLabel,
  videos as videosLabel,
  ebooks as ebooksLabel
} from '../labels';

export function filterItemsByLabel(items, label) {
  return orderByTitle(_.filter(items, item => item.label === label));
}

export function filterItemsByRoute(items, route) {
  let itemsFiltered = orderByTitle(items);
  switch (route) {
    case whitepapersLabel:
      itemsFiltered = filterItemsByLabel(items, 'whitepaper');
      break;
    case webinarsLabel:
      itemsFiltered = filterItemsByLabel(items, 'webinar');
      break;
    case videosLabel:
      itemsFiltered = filterItemsByLabel(items, 'videos');
      break;
    case ebooksLabel:
      itemsFiltered = filterItemsByLabel(items, 'ebook');
      break;
    case 'home':
      break;
    default:
      break;
  }
  return itemsFiltered;
}

export function orderByTitle(items) {
  return _.orderBy(items, item => item.title);
}

export default {
  filterItemsByLabel,
  filterItemsByRoute,
  orderByTitle
};



// WEBPACK FOOTER //
// ./src/pages/resources/utils/resources.js